import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * IDトークン取得API
 */
export namespace ApiTaLi140 {
  // API Name
  export const name: string = 'ApiTaLi140'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/idToken'

    export interface Request {}

    export interface Response {
      id_token: string // eslint-disable-line camelcase
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    /**
     * IDトークンを取得する
     * @param _params リクエストパラメータ（空オブジェクト）
     * @param successHandler 成功時のハンドラ
     * @param errorHandler エラー時のハンドラ
     * @returns ハンドラの戻り値またはnull
     */
    public get<R>(
      _params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        id_token: '', // eslint-disable-line camelcase
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
